import IHistory from './IHistory';

export default superclass => class extends (IHistory, superclass) {

  constructor(componentProps, elementProps) {
    const props = elementProps || [];
    super(componentProps, props);

    this.setupProxy(props);

  }
  /*
  this.properties = {
    group1: [
      {
      key: ...
    }
  ]
}
   */

  onPropertyUpdate(prop) {}

  setupProxy(props) {
    const self = this;
    const handler = {
      set(target, key, value) {
        target[key] = value;
        if(typeof value === 'object')
          self.onPropertyUpdate(value);
        return true;
      },
    };
    this.properties = new Proxy(props, handler);
  }

  setProperties(props) {
    // this.properties = props;
    this.setupProxy(props);
  }

  getPropertiesObject() {
    return this.properties;
  }

  get(key) {
    let p = this.properties.find(el => el.key.toLowerCase() === key.toLowerCase());
    return p;
  }

  getValue(key) {
    const p = this.get(key);
    if(!p) return null;
    return p.value;
  }

  setValue(key, value) {
    this.set(key, null, value);
    if(this.owner)
      this.owner.props.parent.toolbar.document.notifyPanel("updateProperty", key, value);
    if(this.getElement)
      this.getElement().style[key] = value;
  }

  set(key, type, value) {
    let prop = this.get(key);
    const newProp = { key, type: type || (prop ? prop.type : "string"), value};
    (prop ? this.properties[this.properties.indexOf(prop)] = newProp : this.properties.push(newProp));
  }

}



// WEBPACK FOOTER //
// ./src/interfaces/IProperties.js